<script>
    // System
    const VERSION = "1.0.0";

    // const API_URL = '/prod-api/';
    // const API_URL = 'http://127.0.0.1:10061/';
    // const API_URL = '/prod-api/';
	// const API_URL = 'https://parking-saas-test.chinasinoair.com/bmw-api/'
  //    const API_URL = '/prod-api/';
	// const API_URL = 'http://localhost:10061/'
	// const API_URL = 'https://parking-saas-test.chinasinoair.com/bmw-api/'

    const API_URL = process.env.VUE_APP_API_BASE

// Web登录接口
const WEB_LOGIN_API = API_URL + "api/user/loginByPhone"; //用户登录方法
const WEB_LOGOUT_API = API_URL + "api/user/logout"; //用户登录方法
const WEB_LOFINBIND_API = API_URL + "api/user/checkBinding"; //登录绑定检查
const KAPTCHA_GET_API = API_URL + "api/common/kaptcha/generateKaptcha";
const WEB_LOGINCODE_API = API_URL + "api/user/sendVerifySms"; //用户登录获取验证码
const WEB_PARKING_API = API_URL + "api/parking/parkingList"; //车区列表
const WEB_USEREDIT_API = API_URL + "api/user/userEdit"; //用户信息
const WEB_USERINFO_API = API_URL + "api/user/userInfo"; //获取用户信息
const WEB_PARKINGPRICONGLIST_API = API_URL + "api/parking/pricingList"; //价格列表
const WEB_CANCELORDERCONFIRM_API = API_URL + "api/order/cancelOrderConfirm"; //取消订单前确认
const WEB_PLACEANORDER_API = API_URL + "api/order/placeAnOrder"; //下单
const WEB_PLACECANORDER_API = API_URL + "api/order/placeCanOrder"; //预约车区前确认
const WEB_PLACEDISPERSERORDER_API = API_URL + "api/order/placeDisperserOrder"; //下单
// const WEB_CAN9CELORDERCONFIRM_API = API_URL + "api/order/cancelOrderConfirm";//取消订单前确认
const WEB_CANCELORDER_API = API_URL + "api/order/cancelOrder"; //取消订单
const WEB_MANUALENTER_API = API_URL + "api/order/manualEnter"; //手动入场
const WEB_MANUALLEAVE_API = API_URL + "api/order/manualLeave"; //手动入场
const WEB_ORDERLIST_API = API_URL + "api/order/orderList"; //订单列表
const WEB_ORDERLISTBYDETAILS_API = API_URL + "api/order/orderDetails"; //订单详情
const WEB_APPLYINVOICE_API = API_URL + "api/order/applyInvoice"; //申请发票
const WEB_COMMONLYPRICELIST_API = API_URL + "api/parking/commonlyPriceList"; //常用时间列表
// const WEB_PREPAYORDERINFO_API = API_URL + "api/order/prePayOrderInfo";//下单成功后获取订单信息预支付信息
const WEB_ADDCOMPLAINT_API = API_URL + "api/order/complaint"; //投诉建议
const WEB_INVOICELIST_API = API_URL + "api/order/invoiceList"; //历史发票
const WEB_INVOICEINFO_API = API_URL + "api/order/invoiceInfo"; //发票详情
const WEB_USERORDERSTATUS_API = API_URL + "api/order/userOrderStatus"; //用户未完成的订单跳转
const WEB_PARKINGTIME_API = API_URL + "api/order/parkingTime"; //计时
const WEB_PROVINCE_API = API_URL + "api/parking/plateList"; //省份列表
const WEB_ORDER_STATUS_API = API_URL + "api/order/orderStatus"; //计时
const WEB_GOPAY_API = API_URL + "api/order/goWxPay"; //微信下单
const WEB_UPDATEUSERPHONE_API = API_URL + "api/user/updateUserPhone"; //修改手机号
const WEB_WX_JSAPI_API = API_URL + "api/pay/getWxBaseInfo"; //微信JSAPI
const WEB_USER_BINDVIPCARD_API = API_URL + "api/user/bindVIPCard"; //绑定Vip卡
const WEB_USER_VIPCARDINFO_API = API_URL + "api/user/vipCard"; //Vip卡详情
const WEB_CANCELPROCINGDETAILS_API =
  API_URL + "api/cancelPricing/cancelPricingDetails"; //扣费规则
const WEB_TIMEOUTPRICINGDETAILS_API =
  API_URL + "api/cancelPricing/timeoutPricingDetails"; //超时计费规则
const WEB_GETCITY_API = API_URL + "api/parking/getCity"; //获取当前城市
const WEB_GETCITYLIST_API = API_URL + "api/parking/getCityList"; //获取当前城市

const WEB_ROADBOOKLIST_API = API_URL + "api/roadbook/list";
const WEB_UPLOAD_IMAGES_API = API_URL + "api/uploadImages";
const WEB_OCR_VEHICLE_LICENSE_API = API_URL + "api/ocrVehicleLicense";
const WEB_USER_AUTH_VEHICLE_LICENSE_API =
  API_URL + "api/user/userCar/auth/vehicleLicense";
const WEB_QUERY_VEHICLE_LICENSE_AUTH_API =
  API_URL + "api/user/query/vehicleLicense/auth";
const WEB_UNBIND_VEHICLE_LICENSE_API =
  API_URL + "api/user/unbind/vehicleLicense";
const WEB_START_CHARGE_API = API_URL + "api/order/start/charge";
const WEB_STOP_CHARGE_API = API_URL + "api/order/stop/charge";

export default {
  VERSION,
  // API
  API_URL,
  // Web
  WEB_LOGIN_API,
  WEB_LOGOUT_API,
  WEB_LOFINBIND_API,
  WEB_LOGINCODE_API,
  KAPTCHA_GET_API,
  WEB_PARKING_API,
  WEB_USEREDIT_API,
  WEB_USERINFO_API,
  WEB_PARKINGPRICONGLIST_API,
  WEB_PLACEANORDER_API,
  WEB_PLACECANORDER_API,
  WEB_PLACEDISPERSERORDER_API,
  WEB_CANCELORDERCONFIRM_API,
  WEB_CANCELORDER_API,
  WEB_MANUALENTER_API,
  WEB_MANUALLEAVE_API,
  WEB_ORDERLIST_API,
  WEB_ORDERLISTBYDETAILS_API,
  WEB_APPLYINVOICE_API,
  WEB_COMMONLYPRICELIST_API,
  WEB_ADDCOMPLAINT_API,
  WEB_INVOICELIST_API,
  WEB_INVOICEINFO_API,
  WEB_USERORDERSTATUS_API,
  WEB_PARKINGTIME_API,
  WEB_PROVINCE_API,
  WEB_ORDER_STATUS_API,
  WEB_GOPAY_API,
  WEB_UPDATEUSERPHONE_API,
  WEB_WX_JSAPI_API,
  WEB_USER_BINDVIPCARD_API,
  WEB_USER_VIPCARDINFO_API,
  WEB_CANCELPROCINGDETAILS_API,
  WEB_TIMEOUTPRICINGDETAILS_API,
  WEB_GETCITY_API,
  WEB_GETCITYLIST_API,
  WEB_ROADBOOKLIST_API,
  WEB_UPLOAD_IMAGES_API,
  WEB_OCR_VEHICLE_LICENSE_API,
  WEB_USER_AUTH_VEHICLE_LICENSE_API,
  WEB_QUERY_VEHICLE_LICENSE_AUTH_API,
  WEB_UNBIND_VEHICLE_LICENSE_API,
  WEB_START_CHARGE_API,
  WEB_STOP_CHARGE_API,
};
</script>
